import { toBlob } from "html-to-image";

/**
 * Render a DOM node to PNG and hand it to the OS share sheet (LINE etc.),
 * falling back to a download where file sharing is unsupported.
 */
export async function shareNodeAsImage(
  node: HTMLElement,
  fileName: string,
): Promise<void> {
  const blob = await toBlob(node, { pixelRatio: 2 });
  if (!blob) throw new Error("Could not render the image");
  const file = new File([blob], fileName, { type: "image/png" });

  if (navigator.canShare?.({ files: [file] })) {
    try {
      await navigator.share({ files: [file] });
      return;
    } catch (err) {
      if (err instanceof DOMException && err.name === "AbortError") return;
      // any other failure: fall through to a plain download
    }
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();
  URL.revokeObjectURL(url);
}
